export default __webpack_public_path__ + "static/media/Custom-HUD-Dock Icons (7 Icons).769425eb.jpg";